// extracted by mini-css-extract-plugin
module.exports = {"input":"BaseInput_input__HO0hA","arrows":"BaseInput_arrows__2MN3v"};